<phx-select
    #selectComponent
    [placeholder]="props.placeholder"
    [multiple]="!!props.multiple"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [items]="props.options"
    optionValue="value"
    optionLabel="label"
    [selectedItemTemplate]="getItemTemplate()"
    [itemTemplate]="getItemTemplate()"
    [dataTestId]="props.dataTestId"
    (onFilter)="onFilter($event)"
>
    <ng-template #itemTemplate let-item>
        <span>{{ item.label | translate }}</span>
    </ng-template>
    <ng-template #localeTemplate let-item>
        {{ item.label }} ({{ item.label | localeRegionName }})
    </ng-template>
</phx-select>
